import type { APPLICANT_ATTRIBUTION, APPLICANT_ATTRIBUTION_BOTH_TYPE } from 'cpool-constants';
import type { FieldErrors } from 'react-hook-form';

import { extractErrorPaths } from '~/features/leadDetails/hooks/useTabErrorNotification.ts';

type ApplicantAttributedValues = Record<
    string,
    Array<{ gehoertZuAntragsteller?: APPLICANT_ATTRIBUTION_BOTH_TYPE }> | undefined
>;

export function countRowErrorsForApplicant(
    errors: FieldErrors,
    values: ApplicantAttributedValues,
    attribution: APPLICANT_ATTRIBUTION,
): number {
    return Object.entries(errors).reduce((total, [type, typeErrors]) => {
        if (!Array.isArray(typeErrors)) return total;

        const rowErrorCount = typeErrors.reduce((sum, rowErrors, index) => {
            if (!rowErrors || values[type]?.[index]?.gehoertZuAntragsteller !== attribution) return sum;

            return sum + extractErrorPaths(rowErrors).length;
        }, 0);

        return total + rowErrorCount;
    }, 0);
}
